<template>
  <v-footer class="footer mt-4 bg-primary">
    <v-card
        tile
        flat
        width="100%"
        height="100%"
        class="bg-primary d-flex align-center justify-center">
      <p v-html="footer"></p>
    </v-card>
  </v-footer>
</template>

<style>
  .footer {
    min-height: 100px;
    max-height: 150px;
  }
</style>
<script>
import {main} from "@/api";
import commonStore from "@/store/common";

export default {
  name: "ContentFooter",
  data() {
    return {
      footer: "",
    }
  },
  created() {
    this.getFooterInfo()
  },
  methods: {
    getFooterInfo() {
      main.getNoticeList(commonStore.state.common.corpCode, 'footer')
          .then(data => {
            console.log('footer', data)
            this.footer = data.data.notices[0].comment
          })
          .catch(err => {
            console.log(err)
            if (err.isAlert) {
              alert(err.result.error_message)
            }
          })
    },
  }
}
</script>

<style scoped>

</style>